module.exports = __webpack_public_path__ + "static/media/BRB.c2cf571e.png";